import React from "react";
import "./Terms.css";

const Terms = () => {
  return (
    <div>
      <h2>Terms of Service</h2>
      <p>
        These terms and conditions mandate the terms on which the users ("You"
        or "Your" or "User") access, register, browse, download or use the
        mobile application 'GoldBee' ("App") and website www.goldbee.in
        (collectively referred to as, "the Platform") operated and managed by
        Spendiq fintech Private Limited, having its office at C/o 216, Manjeera
        Megistic Commercial, KPHB Colony,Hi-tech city road, Hyderabad - 500085
        ("Company", "We" or "Us").
      </p>

      <p>
        Please read these terms and conditions and privacy policy (available on{" "}
        <a href="https://goldbee.in/privacy">https://goldbee.in/privacy</a>)
        ("Privacy Policy") carefully before registering on the Platform or
        accessing any material, information through the Platform. By registering
        on or accessing the Platform, you agree to be bound by the terms and
        conditions of Platform Services (defined below) and applicable
        service-specific terms and conditions ("Augmont Terms") (collectively
        called "Terms of Use"). The Company retains an unconditional right to
        modify or amend the Terms of Use without any requirement to notify you
        of the same. You can determine when this Terms of Use was last modified
        by referring to the "Last Updated" legend above. It shall be your
        responsibility to check the Terms of Use periodically for changes. Your
        acceptance of the amended Terms of Use shall signify your consent to the
        changes and the agreement to be legally bound by the same. If at any
        time you do not accept or agree with Terms of Use or do not wish to be
        bound by the same, you may not access, browse or use the Platform and
        immediately terminate your availing the Platform Services (as defined
        below).
      </p>

      <h2>Platform Services</h2>
      <p>
        You acknowledge that the Platform is a web service that allows you to
        avail the services directly from the Company including their products
        and services. As long as you accept and comply with the Terms of Use,
        the Company grants you, a limited, non-exclusive, non-transferable,
        royalty free license to use the Platform for the purposes of availing
        the services from Company, collectively hereinafter referred to as (the
        "Platform Services"). The Platform allows the Users to buy and sell
        digital gold. This is done through two methods:
      </p>
      <ol>
        <li>
          Once User downloads the App, User can directly buy/sell a digital
          gold.
        </li>
        <li>
          Each time User purchases any good or service from our identified
          partner store ("Partner Store") through the App, any
          cashback/refund/gift voucher receivable to the User from the Partner
          Store shall be invested into digital gold.
        </li>
      </ol>
      <p>
        We purchase digital gold on your behalf from Augmont Goldtech Private
        Limited ("Augmont"). We are not responsible for the quality of gold
        offered and sold by Augmont and that any disputes in relation to the
        quality of gold shall be raised directly between Augmont and the end
        User. The relation between the User and Augmont shall be governed by the
        Augmont Terms included in the Terms of Use and any other agreements
        signed between you and Augmont. To provide you the Platform Services, we
        maintain a record of your personal information and financial
        transactions in a secure and confidential manner. This also allows us to
        promptly and efficiently respond to your queries relating to your
        Account (defined below). It is hereby clarified that the Company is
        merely providing a platform to its Users to facilitate the transaction
        of purchase and sale of digital gold. Please note that the Company only
        facilitates the purchase/sale through the Platform and will not be
        liable in any manner with respect to the products/services allotted to
        you. You hereby agree and acknowledge that the data and information
        provided on the Platform does not constitute advice of any nature
        whatsoever, and shall not be relied upon by you while making investment
        decisions and you shall be solely responsible for any investment
        decisions. In no event shall the Company be liable to you for any loss
        or damage that may cause or arise from or in relation to these Terms of
        Use and/or due to use of this Platform. In case of any dissatisfaction
        with the Platform Services, you shall first file a formal complaint with
        the customer service of the Company, as may be applicable, prior to
        pursuing any other recourse. The complaints can be lodged at
        admin@goldbee.in and upon lodging a complaint, you agree to provide
        complete support to the customer service team with such reasonable
        information as may be sought by them from you. The decision of the
        Company, as may be applicable, on the complaints shall be final and you
        agree to be bound by the same.
      </p>

      <h2>Use of the Platform</h2>
      <p>
        Subject to acceptance and compliance with the Terms of Use, the Company
        hereby grants you a non-exclusive, limited privilege to access and use
        this Platform. You agree to use the Platform only:
      </p>
      <ol>
        <li>For purposes that are permitted by the Terms of Use; and</li>
        <li>
          In accordance with any applicable law, regulation or generally
          accepted practices or guidelines.
        </li>
      </ol>
      <p>
        You agree that you shall not copy, reproduce, sell, redistribute,
        publish, enter into a database, display, perform, modify, alter,
        transmit, license, create derivatives from, transfer or in any way
        exploit any part of any information, content, materials, services
        available from or through the Platform, except that you may download the
        Platform for your own personal, internal use and non-commercial use. You
        agree that you will not use the Platform in any manner or engage in any
        activity that may damage, disable or impair or adversely affect the use
        of the Platform or interfere with any other users’ use, legal rights, or
        enjoyment of the Platform. Further, you agree not to remove any text,
        copyright or other proprietary notices contained in the content
        downloaded from the Platform.
      </p>
      <p>Further, you undertake not to:</p>
      <ul>
        <li>
          Defame, abuse, harass, threaten or otherwise violate the legal rights
          of others.
        </li>
        <li>
          Publish, post, upload, distribute or disseminate any inappropriate,
          profane, defamatory, infringing, obscene, indecent or unlawful topic,
          name, material or information.
        </li>
        <li>
          Copy, republish, post, display, translate, transmit, reproduce or
          distribute any content on the Platform through any medium without
          obtaining the necessary authorization from the Company.
        </li>
        <li>
          Conduct or forward surveys, contests, pyramid schemes or chain
          letters.
        </li>
        <li>
          Upload or distribute files that contain software or other material
          protected by applicable intellectual property laws unless you own or
          control the rights thereto or have received all necessary consents.
        </li>
        <li>
          Upload or distribute files that contain viruses, corrupted files, or
          any other similar software or programs that may damage the operation
          of the Platform or another’s computer.
        </li>
        <li>
          Engage in any activity that interferes with or disrupts access to the
          Platform (or the servers and networks which are connected to the
          Platform).
        </li>
        <li>
          Attempt to gain unauthorized access to any portion or feature of the
          Platform, any other systems or networks connected to the Platform, to
          any of the Company’s server, or through the Platform, by hacking,
          password mining or any other illegitimate means.
        </li>
        <li>
          Probe, scan or test the vulnerability of the Platform or any network
          connected to the Platform, nor breach the security or authentication
          measures on the Platform or any network connected to the Platform. You
          may not reverse look-up, trace or seek to trace any information on any
          other User, of or visitor to, the Platform, to its source, or exploit
          the Platform or information made available or offered by or through
          the Platform, in any way whether or not the purpose is to reveal any
          information, including but not limited to personal identification
          information, other than your own information, as provided on the
          Platform.
        </li>
        <li>
          Disrupt or interfere with the security of, or otherwise cause harm to,
          the Platform, systems resources, accounts, passwords, servers or
          networks connected to or accessible through the Platform or any
          affiliated or linked sites.
        </li>
        <li>
          Collect or store data about other Users in connection with the
          prohibited conduct and activities.
        </li>
        <li>
          Use any device or software to interfere or attempt to interfere with
          the proper working of the Platform or any transaction being conducted
          on the Platform, or with any other person’s use of the Platform.
        </li>
        <li>
          Use the Platform or any material or content for any purpose that is
          unlawful or prohibited by these Terms of Use, or to solicit the
          performance of any illegal activity or other activity which infringes
          the rights of the Company or other third parties.
        </li>
        <li>
          Falsify or delete any author attributions, legal or other proper
          notices or proprietary designations or labels of the origin or source
          of software or other material contained in a file that is uploaded.
        </li>
        <li>
          Violate any applicable laws or regulations for the time being in force
          within or outside India or anyone’s right to privacy or personality.
        </li>
        <li>Violate the Terms of Use contained herein or elsewhere.</li>
        <li>
          Reverse engineer, modify, copy, distribute, transmit, display,
          perform, reproduce, publish, license, create derivative works from,
          transfer, or sell any information or software obtained from the
          Platform.
        </li>
      </ul>

      <p>
        <b>Intellectual Property Rights</b>
        <br />
        <br />
        The Platform and all information, content, materials, products
        including, but not limited to text, content, photographs, graphics,
        texts, video and audio content and computer code ("Content") on the
        Platform is owned and controlled by the Company and the design,
        structure, selection and feel and arrangement of the Content is
        protected by copyright, patent and trademark laws and other various
        intellectual property rights either in the favor of the Company or third
        parties from whom the appropriate permissions have been taken under
        applicable laws. The trademarks, logos and service marks displayed on
        the Platform ("Marks") are the property of the Company and its
        affiliates or other respective third parties, as the case may be. You
        are not permitted to use the Marks without the express prior written
        consent of the Company or the third party that owns the Marks. Further,
        you understand and accept that all information, except your personal
        information and other data submitted by you for the purposes of
        transacting on the Platform, through the Platform shall be deemed the
        property of the Company, and the Company shall be free to use any ideas,
        concepts, know-how or techniques provided by you on the Platform, in any
        manner whatsoever. On initiating a contact or query through the
        Platform, you agree to be contacted by the Company or any other entities
        with whom the Company has entered into an arrangement for the provisions
        of Platform Services to you.
        <br />
        <br />
        Disclaimer of Warranties, Indemnification and Limitation of Liability
        <br />
        <br />
        You expressly understand and agree that, to the maximum extent permitted
        by applicable law, the Platform and other Content are provided by the
        Company on an "as is" basis without warranty of any kind, express,
        implied, statutory or otherwise, including the implied warranties of
        title, non-infringement, merchantability or fitness for a particular
        purpose. Without limiting the foregoing, the Company makes no warranty
        that (i) the Platform or Platform Services will meet your requirements
        or your use of the Platform will be uninterrupted, timely, secure or
        error-free; (ii) the results that may be obtained from the use of the
        Platform will be effective, accurate or reliable; (iii) any errors or
        defects in the Platform will be corrected. No advice or information,
        whether oral or written, obtained by you from the Company shall create
        any warranty not expressly stated in the Terms of Use. The Company will
        have no liability related to any user Content arising under intellectual
        property rights, libel, privacy, publicity, obscenity or other laws. The
        Company also disclaims all liability with respect to the misuse, loss,
        modification or unavailability of any user Content. Further, the Company
        will not be liable for any loss that you may incur as a consequence of
        unauthorized use of your Account (defined below) or Account (defined
        below) information in connection with the Platform or the Platform
        Services either with or without your knowledge. The Company and its
        affiliates have endeavored to ensure that all the information on the
        Platform is correct, but the Company and/ or its affiliates neither
        warrants nor makes any representations regarding the quality, accuracy
        or completeness of any data, information regarding the Platform Services
        or otherwise. The Company shall not be responsible for the delay or
        inability to use the Platform or related functionalities, the provision
        of or failure to provide functionalities, or for any information,
        software, functionalities and related graphics obtained through the
        Platform, or otherwise arising out of the use of the Platform, whether
        based on contract, tort, negligence, strict liability or otherwise.
        Further, the Company shall not be held responsible for non-availability
        of the Platform during periodic maintenance operations or any unplanned
        suspension of access to the Platform that may occur due to technical
        reasons or for any reason beyond the Company's control. You understand
        and agree that any material or data downloaded or otherwise obtained
        through the Platform is done entirely at your own discretion and risk,
        and that you will be solely responsible for any damage to your computer
        systems or loss of data that results from the download of such material
        or data. You acknowledge that the software and hardware underlying the
        Platform as well as other internet related software which are required
        for accessing the Platform are the legal property of the respective
        vendors. The permission given by the Company to access the Platform will
        not convey any proprietary or ownership rights in the above
        software/hardware to you. Please note that not all the Platform Services
        are available in all geographical areas and depending on your location,
        you may not be eligible to avail certain Platform Services offered by
        the Company as the case may be. The Company reserve the absolute right
        to determine the availability and eligibility for any of the Platform
        Service offered on the Platform. The Company is not responsible for the
        availability of content or other services on third party sites linked
        from the Platform and the Company urges you to read the terms of use of
        the respective third party sites, before accessing or registering with
        any of such third party sites. Further, the Company does not make any
        warranties and expressly disclaims all warranties express or implied,
        including without limitation, those of merchantability and fitness for a
        particular purpose, title or non-infringement with respect to any
        information or services or products that are available or advertised or
        sold through these third-party websites. The Company shall not be liable
        for failure or error of any transaction on the Platform or for any
        failure on part of the Company to perform any of its obligations under
        these Terms of Use if performance is prevented, hindered or delayed by a
        Force Majeure event (defined below) and in such case its obligations
        under these Terms of Use shall be suspended for so long as the Force
        Majeure event continues. The term "Force Majeure Event" means any event
        due to any cause beyond the reasonable control of the Company, including
        without limitations, unavailability of any communication systems,
        breach, or virus in the processes or payment or delivery mechanism,
        sabotage, fire, flood, explosion, acts of god, civil commotion, strikes
        or industrial action of any kind, riots, insurrection, war, acts of
        government, computer hacking, unauthorised access to computer data and
        storage devices, computer crashes, malfunctioning in the computer
        terminal or the systems getting affected by any malicious, destructive
        or corrupting code or program, mechanical or technical errors/failures
        or power shut down, faults or failures in telecommunication etc.
        Further, you will not dispute responsible for: (i) any act that is not
        an obligation of Company under the Terms of Use; (ii) any disclosures
        made by Company to any statutory body under any law; and (iii)
        processing of instructions authenticated by your login credentials,
        non-availability or non-accessibility of the Platform, telephone(s), or
        office(s) of Company in case of circumstances beyond Company's control.
        You agree to indemnify the Company, its directors and employees from any
        losses, damages, penalties, claims, costs and demands (including
        reasonable attorney fees and legal costs) arising out of breach or
        non-performance and/or non-observance of the duties and obligations,
        representations, warranties and covenants under the Terms of Use or due
        to your acts or omissions. You further agree to hold the Company
        harmless against any claims made by any third party due to, or arising
        out of, or in connection with, your use of the Platform, any
        misrepresentation with respect to the data or information provided by
        you, your violation of the Terms of Use, or your violation of any rights
        of another, including any intellectual property rights. In no event
        shall the Company and its officers, partners, consultants, agents and
        employees, be liable to you or any third party for any special,
        incidental, indirect, consequential or punitive damages whatsoever,
        arising out of or in connection with your use of or access to the
        Platform or Content on the Platform. The limitations and exclusions in
        the Terms of Use apply to the maximum extent permitted by applicable
        laws. You warrant that all the details and information provided by you
        to the Company while using this Platform (including for the purposes of
        carrying out investments) are correct, accurate and genuine. You further
        warrant that providing such details and information on the Platform or
        sharing of the aforesaid details/information shall not violate any third
        – party rights or the intellectual property right of any third party.
      </p>

      <p>
        <b>Eligibility:</b> By accepting the Terms of Use, you hereby represent
        that:
        <br />
        <br />
        1. You are of 18 (eighteen) years of age or older and in case, you are
        acting as guardian on behalf of a minor, you have the necessary
        authority to register/sign up on the Platform for availing the Services
        on behalf of the minor;
        <br />
        2. You are of legal age to form a binding contract, are not a person
        barred from receiving the Platform Services under the applicable laws
        and are competent to enter into a binding contract. The Company reserves
        the right to refuse access to the Platform to new Users and any such
        user who has been suspended or removed by the Company for any reason
        whatsoever shall not been entitled to avail the Platform Services;
        <br />
        3. You agree to abide by the Terms of Use, Privacy Policy and any other
        information provided by you on and through the Platform for the
        provision of the Platform Services;
        <br />
        4. The money you invest is from your bank account, and the same is from
        legitimate sources and remitted through approved banking channels;
        <br />
        5. You are prohibited from selling, trading, or otherwise transferring
        your Account (defined below) to another party or impersonating any other
        person for the purposing of creating an account with the Platform;
        <br />
        6. You agree to make an informed independent decision while purchasing
        or selling digital gold through the Platform; and Account, Password and
        Security In order to access the Platform Services on the Platform and
        your account on the Platform ("Account"), you will have to register on
        the Platform by providing details including but not limited to mobile
        number, mother's name, father's name, email address, password, date of
        birth, gender, Permanent Account Number (PAN), signature, marital
        status, nominee details, cancelled cheque, photograph and video
        recording, etc. and other information as may be required by the Company
        from time to time. We may also ask you for certain financial
        information, including your billing address, bank account details,
        credit card number, expiration date and/or other payment related details
        or other payment method data, and debit instructions or other standing
        instructions to process payments for the Platform Services. The Company
        may ask you to provide certain additional information about yourself on
        a case-to-case basis. You shall ensure and confirm that the Account
        information provided by you is complete, accurate and up-to-date. If
        there is any change in the Account information, you shall promptly
        update your Account information on the Platform. If you provide any
        information that is untrue, inaccurate, not current or incomplete (or
        becomes untrue, inaccurate, not current or incomplete), or if the
        Company has reasonable grounds to suspect that such information is
        untrue, inaccurate, not current or incomplete, the Company has the right
        to suspend or terminate your Account and refuse any and all current or
        future use of the Platform (or any portion thereof) at its discretion,
        in addition to any right that the Company may have against you at law or
        in equity, for any misrepresentation of information provided by you. You
        will be responsible for maintaining the confidentiality of the Account
        information and are fully responsible for all activities that occur
        under your Account and also agree to keep your login credentials safe
        and confidential at all times. You further agree to promptly change your
        login credentials and inform the Company immediately in case of any
        actual or suspected unauthorized use of your Account. The Company cannot
        and will not be liable for any loss or damage arising from your failure
        to comply with this provision. You may be held liable for losses
        incurred by the Company or any other user of or visitor to the Platform
        due to authorized or unauthorized use of your Account as a result of
        your failure in keeping your Account information secure and
        confidential.
        <br />
        <br />
        <b>Violation of the Terms of Use</b>
        <br />
        <br />
        You agree that any violation by you of these Terms of Use will
        constitute an unlawful and unfair business practice and will cause
        irreparable harm to the Company, as the case may be, for which monetary
        damages would be inadequate, and you consent to the Company obtaining
        any injunctive or equitable relief that they deem necessary or
        appropriate in such circumstances. These remedies are in addition to any
        other remedies that the Company may have at law or in equity. If the
        Company takes any legal action against you as a result of your violation
        of these Terms of Use, it will be entitled to recover from you, and you
        agree to pay, all reasonable attorneys’ fees and costs of such action,
        in addition to any other relief that may be granted.
      </p>

      <p>
        <b>Suspension and Termination:</b> The Terms of Use will continue to
        apply until terminated either by you or the Company as set forth below.
        If you object to the Terms of Use or are dissatisfied with the Platform,
        you may (i) close your Account on the Platform; and/or (ii) stop
        accessing the Platform. In case you violate these Terms of Use and/ or
        any applicable law, the Company may, at any time and in its sole
        discretion, terminate your Account and/or prevent you from accessing the
        Platform and/or Platform Services. The Company may delist you or block
        your future access to the Platform or suspend or terminate your Account
        if it believes, in its sole and absolute discretion that you have
        infringed, breached, violated, abused, or unethically manipulated or
        exploited any term of these Terms of Use or anyway otherwise acted
        unethically or against business interest of Company. Notwithstanding
        anything in this clause, these Terms of Use will survive indefinitely
        unless and until the Company chooses to terminate them. If you or the
        Company terminate your use of the Platform, the Company may delete any
        Content (defined below) or other materials relating to you and the
        Company shall have no liability to you or any third party for doing so.
        However, your transactions details may be preserved by the Company, as
        permitted by applicable law, for purposes of tax or regulatory
        compliance.
        <br />
        <br />
        <b>Refund policy:</b> The transactions on the Platform with respect to
        the Platform Services will be completed only after successful transfer
        of money from your registered bank account to the Company’s bank
        account. You hereby agree and acknowledge that the transactions on the
        Platform once completed cannot be cancelled by you.
        <br />
        <br />
        <b>Governing laws:</b> The Terms of Use shall be governed and construed
        in accordance with the laws of India without reference to conflict of
        laws principles. All disputes arising in relation to shall be subject to
        the exclusive jurisdiction of court at Hyderabad.
        <br />
        <br />
        <b>Report Abuse:</b> In the event you come across any abuse or violation
        of these Terms of Use or if you become aware of any objectionable
        content on the Platform, please report the same to the following e-mail
        id: admin@GoldBee.in.
        <br />
        <br />
        <b>Communications:</b> You hereby expressly agree to receive
        communication (including transactional messages) or by way of SMS and/or
        E-mail or through WhatsApp from the Company or any third party in
        connection with the Platform Services or your registration on the
        Platform. You can unsubscribe/opt-out from receiving communications
        through e-mail anytime by writing to admin@GoldBee.in.
        <br />
        <br />
        <b>Posts:</b> The Company may provide and display content on the
        Platform which features specific articles/write-ups by third parties in
        relation to digital gold. You hereby agree and acknowledge that such
        content displayed on the Platform does not represent the views and/or
        recommendations of the Company. You may also be allowed to post and
        comment on such content on the Platform and you hereby undertake to
        ensure that such comments shall not be offensive and will be in
        accordance with applicable laws. All material added, created, submitted,
        or posted to the Platform by you is your sole responsibility. The
        Company reserves the right to review any information provided/data
        uploaded, if any, by you on the Platform and delete any information/data
        that is inconsistent with these Terms of Use.
      </p>

      <p style={{ fontFamily: "Arial, sans-serif" }}>
        <strong>Suspension and Termination:</strong> The Terms of Use will
        continue to apply until terminated either by you or the Company as set
        forth below. If you object to the Terms of Use or are dissatisfied with
        the Platform, you may (i) close your Account on the Platform; and/or
        (ii) stop accessing the Platform. In case you violate these Terms of Use
        and/ or any applicable law, the Company may, at any time and in its sole
        discretion, terminate your Account and/or prevent you from accessing the
        Platform and/or Platform Services. The Company may delist you or block
        your future access to the Platform or suspend or terminate your Account
        if it believes, in its sole and absolute discretion that you have
        infringed, breached, violated, abused, or unethically manipulated or
        exploited any term of these Terms of Use or anyway otherwise acted
        unethically or against business interest of Company. Notwithstanding
        anything in this clause, these Terms of Use will survive indefinitely
        unless and until the Company chooses to terminate them. If you or the
        Company terminate your use of the Platform, the Company may delete any
        Content (defined below) or other materials relating to you and the
        Company shall have no liability to you or any third party for doing so.
        However, your transactions details may be preserved by the Company, as
        permitted by applicable law, for purposes of tax or regulatory
        compliance.
        <br />
        <br />
        <strong>Refund policy:</strong> The transactions on the Platform with
        respect to the Platform Services will be completed only after successful
        transfer of money from your registered bank account to the Company’s
        bank account. You hereby agree and acknowledge that the transactions on
        the Platform once completed cannot be cancelled by you.
        <br />
        <br />
        <strong>Governing laws:</strong> The Terms of Use shall be governed and
        construed in accordance with the laws of India without reference to
        conflict of laws principles. All disputes arising in relation to shall
        be subject to the exclusive jurisdiction of court at Hyderabad.
        <br />
        <br />
        <strong>Report Abuse:</strong> In the event you come across any abuse or
        violation of these Terms of Use or if you become aware of any
        objectionable content on the Platform, please report the same to the
        following e-mail id: admin@GoldBee.in.
        <br />
        <br />
        <strong>Communications:</strong> You hereby expressly agree to receive
        communication (including transactional messages) or by way of SMS and/or
        E-mail or through WhatsApp from the Company or any third party in
        connection with the Platform Services or your registration on the
        Platform. You can unsubscribe/opt-out from receiving communications
        through e-mail anytime by writing to admin@GoldBee.in.
        <br />
        <br />
        <strong>Posts:</strong> The Company may provide and display content on
        the Platform which features specific articles/write-ups by third parties
        in relation to digital gold. You hereby agree and acknowledge that such
        content displayed on the Platform does not represent the views and/or
        recommendations of the Company. You may also be allowed to post and
        comment on such content on the Platform and you hereby undertake to
        ensure that such comments shall not be offensive and will be in
        accordance with applicable laws. All material added, created, submitted,
        or posted to the Platform by you is your sole responsibility. The
        Company reserves the right to review any information provided/data
        uploaded, if any, by you on the Platform and delete any information/data
        that is inconsistent with these Terms of Use.
        <br />
        <br />
        <strong>General Provisions Notice:</strong> All notices from the Company
        will be served by email to your registered email address or by general
        notification on the Platform. Any notice provided to the Company
        pursuant to the Terms of Use should be sent to admin@GoldBee.in.
        <br />
        <br />
        <strong>Assignment:</strong> You cannot assign or otherwise transfer the
        Terms of Use, or any rights granted hereunder to any third party. The
        Company’s rights under the Terms of Use are freely transferable by the
        Company to any third party without the requirement of seeking your
        consent.
        <br />
        <br />
        <strong>Severability:</strong> If, for any reason, a court of competent
        jurisdiction finds any provision of the Terms of Use, or any portion
        thereof, to be unenforceable, that provision shall be enforced to the
        maximum extent permissible so as to give effect to the intent of the
        parties as reflected by that provision, and the remainder of the Terms
        of Use shall continue in full force and effect.
        <br />
        <br />
        <strong>Waiver:</strong> Any failure by the Company to enforce or
        exercise any provision of the Terms of Use, or any related right, shall
        not constitute a waiver by the Company of that provision or right.
        <br />
        <br />
        <strong>Augmont Terms:</strong> Please read the following terms and
        conditions before registering on, accessing or using the website
        www.augmont.com ("this Website") or the Augmont mobile application
        (“this App”) or any similar platform (hereinafter collectively called
        the Platform). This Website and this App are owned and operated by
        Augmont Goldtech Private Limited (Formerly Augmont Precious Metals
        Private Limited). We, Augmont Goldtech Private Limited and/or our
        designated affiliates (jointly "Augmont") provide the Platform features
        to you, the user, subject to your acceptance of the following Terms and
        Conditions of Access and Use, constituting an agreement between us
        ("Agreement"). If you continue to use the Platform or communicate with
        us, you will be deemed to have accepted these Terms and Conditions of
        Access and Use. Please read these Terms and Conditions of Access and Use
        carefully. In addition, when you use any current or future Augmont
        service or business you will also be subject to the guidelines, terms
        and agreements applicable to such service or business ("Specific
        Terms"). If the Terms and Conditions of Access and Use are expressly
        inconsistent with such Specific Terms, the Specific Terms will prevail.
        Augmont may revise these Terms and Conditions of Access and Use from
        time to time and at any time, without notice to you. If you do not agree
        to be bound by these Terms and Conditions of Access and Use, as modified
        from time to time, you should leave the Platform immediately. The
        section titles in these Terms and Conditions of Access and Use are for
        convenience only and have no legal effect.
      </p>
      <p style={{ fontFamily: "Arial, sans-serif" }}>
        <strong>ACCEPTANCE OF DISCLAIMERS AND EXCLUSIONS</strong>
        <br />
        You acknowledge that the disclaimers and exclusions of liability set
        forth in these Terms and Conditions of Access and Use represent a fair
        and reasonable allocation of the risks and benefits of the Agreement
        between you and us, taking all relevant factors into consideration. You
        agree that these disclaimers and limitations shall be enforceable to the
        fullest extent permitted by applicable law. You agree that regardless of
        any statute or law to the contrary, any claim or cause of action arising
        out of or related to use of the Platform or these Terms and Conditions
        of Access and Use must be filed within one (1) year after such claim or
        cause of action arose or be forever barred. These Terms and Conditions
        of Access and Use shall be read in conjunction with the Business Rules
        of Augmont and of the Platform. Augmont may revise these Business Rules
        from time to time and at any time, without notice to you.
        <br />
        <br />
        <strong>Business Rules</strong>
        <br />
        The Platform shall facilitate purchase and sale of Gold and Silver with
        each of its specific users (such users are referred to as “Registered
        Members”). Bullion can be bought and sold online using the Platform's
        buying/selling option. Registered Member can buy/sell any quantity of
        gold and silver on the Platform. The value of Bullion is in INR terms
        and excludes GST and other applicable taxes. Both Buy and Sell prices of
        Bullion will be quoted exclusive of GST. Augmont shall raise e-invoices
        for the Bullion sold. Augmont shall provide buy/sell rates of Bullion,
        Registered Members shall have the option to either sell the Bullion to
        Augmont at the prevailing market prices or allow the custodian to store
        the bullion in the designated vaults or to request for the delivery of
        the Gold/Silver bought in the form of coins and bars online with us.
        <br />
        <br />
        <strong>COPYRIGHT</strong>
        <br />
        All content included on the Platform such as text, graphics, logos,
        button icons, images, audio clips, digital downloads, data compilations,
        and software, is the property of Augmont or its content suppliers and is
        protected by international copyright laws. All software used on this
        site is the property of Augmont or its software suppliers and is
        protected by international copyright laws. The content of the Platform
        cannot be copied, reproduced, republished, uploaded, posted,
        transmitted, or distributed for any non-personal use without the prior
        written approval of Augmont. Graphics, logos, page headers, button
        icons, scripts, and service names contained in or featured on the
        Platform are trademarks or trade dress of Augmont. Augmont's trademarks
        may not be used in connection with any other product or service, in any
        manner that is likely to cause confusion, disparage or discredit
        regarding Augmont and its products and services. All trademarks not
        owned by Augmont that appear on this site are the property of their
        respective owners, who may or may not be affiliated with, connected to,
        or sponsored by Augmont.
        <br />
        <br />
        <strong>DISCLAIMER OF WARRANTIES</strong>
        <br />
        The Platform and all information, content, materials, products
        (including software), and services included on or otherwise made
        available to you through the Platform are provided by Augmont on an "as
        is" and "as available" basis unless otherwise specified in writing.
        Augmont makes no representations or warranties of any kind, express or
        implied, as to the operation of this site or the information, content,
        materials, products (including software), or services included on or
        otherwise made available to you through this site unless otherwise
        specified in writing. You expressly agree that your use of this site is
        at your sole risk. To the full extent permissible by applicable law,
        Augmont disclaims all warranties, express or implied, including but not
        limited to implied warranties of merchantability and fitness for a
        particular purpose. Augmont does not warrant that this site;
        information, content, materials, products (including software), or
        services included on or otherwise made available to you through this
        site; their servers; or electronic communications sent from Augmont are
        free of viruses or other harmful components. Augmont will not be liable
        for any damages of any kind arising from the use of this site or from
        any information, content, materials, products (including software), or
        services included on or otherwise made available to you through this
        site, including but not limited to direct, indirect, incidental,
        punitive, and consequential damages unless otherwise specified expressly
        in writing.
        <br />
        <br />
        <strong>DISPUTES</strong>
        <br />
        Any dispute or claim relating in any way to your visit to the Platform
        or to products or services sold or distributed by Augmont or through the
        Platform will be resolved first by arbitration. The Indian Arbitration
        and Conciliation Act of 1996 applies to this agreement. To begin an
        arbitration proceeding, you must send a letter requesting arbitration
        and describing your claim in detail to our address available on the
        Platform. The arbitration will be conducted in Mumbai by an independent
        arbitrator appointed by Augmont. The costs of arbitration proceedings
        will be borne by the party so instructed by the arbitrator, on the
        merits of the case. We each agree that any dispute resolution
        proceedings will be conducted only on an individual basis and not in a
        class, consolidated, or representative action.
        <br />
        <br />
        <strong>ELECTRONIC COMMUNICATIONS</strong>
        <br />
        When you visit the Platform or send emails to us, you are communicating
        with us electronically. You consent to receive communications from us
        electronically. We may communicate with you by one or more of letters,
        e-mail, SMS, or by posting notices on the Platform. You agree that all
        agreements, notices, disclosures, and other communications that we
        provide to you electronically satisfy all legal requirements that such
        communications be in writing.
        <br />
        <br />
        <strong>EQUIPMENT</strong>
        <br />
        You shall procure and maintain all communication and other equipment
        necessary to access the Platform, and the costs of any such equipment
        and communication connections or use, including any applicable taxes,
        shall be borne solely by you. You are responsible for operating your own
        equipment used to access the Platform.
        <br />
        <br />
        <strong>FINANCIAL TRANSACTIONS AND TAXES</strong>
        <br />
        If you wish to make any financial transactions on the Platform,
        including paying for products or services, you may be asked for payment
        information. You agree that all information you provide is accurate,
        complete, and current and that you will pay all charges owed, including
        any applicable taxes. You agree that you are solely responsible for any
        personal income reporting and tax payments required of you by applicable
        government authorities.
      </p>

      <p>
        <strong>GOVERNING LAW AND JURISDICTION</strong>
      </p>
      <p>
        By visiting the Platform, you agree to be bound by the applicable Indian
        laws and State laws, including those pertaining to taxation. This
        Agreement has been executed and delivered in India, and its
        interpretations, validity and performance shall be construed and
        enforced in accordance with the laws of the Republic of India, without
        regard to principles of conflict of laws, and shall be subject to the
        exclusive jurisdiction of courts at Bangalore.
      </p>

      <p>
        <strong>INDEMNIFICATION</strong>
      </p>
      <p>
        You agree to indemnify, defend and hold Augmont harmless from all
        claims, damages and expenses (including attorney's fees) made by any
        third party arising out of your content, your use of the Platform, your
        connection to the Platform, your violation of this Agreement, our Terms
        and Conditions of Access and Use or our business policies, and the
        development, operation, maintenance, use and contents of this Platform.
      </p>

      <p>
        <strong>INDEPENDENT INVESTIGATION</strong>
      </p>
      <p>
        You acknowledge that you have read these Terms and Conditions of Access
        and Use and agree to them in entirety. You understand that we may at any
        time (directly or indirectly) solicit member referrals on terms that may
        differ from those contained in this Terms and Conditions of Access and
        Use. You have independently evaluated the desirability of associating
        with the Platform or of participating in its programs or of availing its
        services and/or products, and are not relying on any representation,
        guarantee or statements other than as set forth in this Terms and
        Conditions of Access and Use.
      </p>

      <p>
        <strong>LICENSE AND SITE ACCESS</strong>
      </p>
      <p>
        Augmont grants you a limited license to access and make personal use of
        this site and not to download (other than page caching) or modify it, or
        any portion of it, except with express written consent of Augmont. This
        license does not include any resale or commercial use of this site or
        its contents; any collection and use of any product listings,
        descriptions, or prices; any derivative use of this site or its
        contents; any downloading or copying of account information for the
        benefit of another merchant; or any use of data mining, robots, or
        similar data gathering and extraction tools. This site or any portion of
        this site may not be reproduced, duplicated, copied, sold, resold,
        visited, or otherwise exploited for any commercial purpose without
        express written consent of Augmont. You may not frame or utilize framing
        techniques to enclose any trademark, logo, or other proprietary
        information (including images, text, page layout, or form) of Augmont
        without its express written consent. You may not use any Meta tags or
        any other "hidden text" utilizing Augmont's name or trademarks without
        the express written consent of Augmont. Any unauthorized use terminates
        the permission or license granted by Augmont. You are granted a limited,
        revocable, and nonexclusive right to create a hyperlink to the Platform
        so long as the link does not portray Augmont, or its products or
        services in a false, misleading, derogatory, or otherwise offensive
        matter. You may not use any Augmont logo or other proprietary graphic or
        trademark as part of the link without express written permission.
      </p>

      <p>
        <strong>LIMITATION OF LIABILITY</strong>
      </p>
      <p>
        You expressly agree that use of the Platform is at your sole risk. While
        we will take all reasonable precautions to ensure uninterrupted and
        error-free operations, your access and use of the Platform is at your
        sole risk. The service is provided on an "as is" and "as available"
        basis. We and our licensors, suppliers, vendors, parent, holding,
        subsidiary and related companies, affiliates, officers, agents and
        employees expressly disclaim all warranties of any kind, whether express
        or implied, including, but not limited to the implied warranties of
        merchantability, fitness for a particular purpose and non-infringement.
        In no event shall Augmont be liable for any direct, indirect,
        incidental, special, punitive, consequential damages, or any damages
        whatsoever, including, but not limited to, damages for loss of profits,
        goodwill, use, data, or other intangible losses resulting from:
        <ul>
          <li>
            The use or the inability to use our services or access content
          </li>
          <li>
            The cost of procurement of substitute goods and services resulting
            from transactions entered into through or from the Platform
          </li>
          <li>
            The unauthorized access to or alterations of your transmissions or
            data
          </li>
          <li>Statements or conduct of any third party on the service</li>
          <li>
            Any other matter relating to any service or product offered,
            delivered or agreed to be delivered, even if Augmont has been
            advised of the possibility of damages
          </li>
        </ul>
      </p>

      <p>
        <strong>OTHER BUSINESSES</strong>
      </p>
      <p>
        For your convenience, the Platform may provide links to the sites of
        affiliated companies and certain other businesses, which may not be in
        our control. You acknowledge that Augmont does not endorse these linked
        sites (even if they pop up in a frame) or any links contained in these
        linked sites. We are not responsible for examining or evaluating, and we
        do not warrant the offerings of, any of these businesses or individuals
        or the content of their website. Augmont does not assume any
        responsibility or liability for the actions, product, and content of all
        these and any other third parties. You should carefully review their
        privacy statements and other conditions of use.
      </p>

      <p>
        <strong>PATENTS</strong>
      </p>
      <p>
        One or more patents owned by Augmont may apply to the Platform and to
        the features and services accessible via the Platform. Portions of the
        Platform may operate under license of one or more patents.
      </p>

      <p>
        <strong>PRICING</strong>
      </p>
      <p>
        Except where noted otherwise, the prices displayed for products on the
        Platform represents the value of the respective product. For certain
        transactions, you shall bear fees and charges in addition to payment for
        prices displayed on the Platform. Such additional fees and charges shall
        be as stated on the Platform. Please pay attention to the details of
        your transactions because your total price for a transaction may include
        taxes, fees, and shipping costs, which you are responsible for paying.
        With respect to services provided or products sold by Augmont, we cannot
        confirm the cost of a service or the price of a product until you order.
        Despite our best efforts, a small number of the items in our catalog may
        be mispriced. If an item's correct price is higher than our stated
        price, we will, at our discretion, either contact you for instructions
        before shipping or cancel your order and notify you of such
        cancellation.
      </p>

      <p>
        <strong>PRIVACY</strong>
      </p>
      <p>
        The Platform is strongly committed to your right to privacy and to
        keeping your information secure. We collect your personal information on
        a need-to-know basis. Personal information includes, but is not limited
        to, first and last name, physical address, email address, phone number,
        birth date, and any other information that itself identifies or when
        tied to the above information, may identify you as a specific
        individual. Additionally, Augmont may require you to provide additional
        information and documents for meeting its Know-Your-Client guidelines.
        The Platform does not collect personally identifiable information about
        you except when you specifically and knowingly provide it. Augmont uses
        your personally identifiable information also to operate the Platform
        and offer its services and to inform you of new features, services, and
        products from Augmont. Augmont may carefully select other companies to
        send you information about their products or services which are related
        to the Platform but are not necessary for its operation (an "Extended
        Service"). You would be provided the option to decline the Extended
        Service. Augmont may disclose your personal information if required to
        do so by law or in the good-faith belief that such action is necessary:
        (a) to conform to the edicts of law or comply with legal process served
        on Augmont; (b) to protect and defend the rights or property (including
        intellectual property) of Augmont and/or of the Platform or (c) to act
        under exigent circumstances (as Augmont may, in its sole decision
        decide) to protect the personal safety of users of the Platform,
        Augmont, or the public. The Platform may have features that provide for
        users to disclose their identities and communicate with other users.
        Your use of such features and disclosure of any personal details (e.g.,
        email address, mobile numbers) by you through these features are at your
        sole risk, and Augmont accepts no responsibility for the same.
      </p>

      <p>
        <strong>PRODUCT DESCRIPTIONS</strong>
      </p>
      <p>
        Augmont attempts to be as accurate as possible. However, Augmont does
        not warrant that product descriptions or other content of this site is
        accurate, complete, reliable, current, or error-free. If a product
        offered by Augmont is not as described, your sole remedy is to return it
        in unused condition for a replacement under the provisions of our
        Replacement Policy.
      </p>

      <p>
        <strong>REPLACEMENT POLICY</strong>
      </p>
      <p>
        The following rules will apply regarding the replacement of articles
        delivered to the customers:
      </p>
      <ul>
        <li>
          Replacement shall be sought in writing no later than three business
          days from the date of delivery to the Registered Member;
        </li>
        <li>
          Replacement shall be subject to the return of the delivered articles
          at Augmont’s office address stated for this purpose on the Platform;
        </li>
        <li>
          It shall be the responsibility of the Registered Member to ensure the
          safe delivery of articles to Augmont’s custody. Till such time that
          the receipt of Bullion is acknowledged as “received” by Augmont, the
          risk of loss of the article shall remain with the concerned Registered
          Member;
        </li>
        <li>
          Replacement shall be subject to the handover of the delivered article
          in its original tamper-proof packing, if any, in an intact, unopened,
          and non-mutilated condition. The decision of Augmont regarding the
          condition of the tamper-proof packing shall be final and conclusive;
          While Augmont shall try to replace a returned piece with a close
          substitute, Augmont shall have the right to replace the returned piece
          with any piece that is similar in composition and equal in market
          value on the date of replacement (although not necessarily similar in
          shape or design) with the returned piece.
        </li>
      </ul>

      <p>
        <strong>REVIEWS, COMMENTS, COMMUNICATIONS, AND OTHER CONTENT</strong>
      </p>
      <p>
        You may post reviews, comments, photos, and other content and submit
        suggestions, ideas, comments, questions, or other information to the
        Platform, as long as the content is not illegal, obscene, threatening,
        defamatory, invasive of privacy, infringing on intellectual property
        rights, or otherwise injurious to third parties or objectionable and
        does not consist of or contain software viruses, political campaigning,
        commercial solicitation, chain letters, mass mailings, or any form of
        spam. You may not use a false email address or mobile number,
        impersonate any person or entity, or otherwise mislead as to the origin
        of a card or other content. Augmont does not regularly review posted
        content but reserves the right (but has no obligation) to remove or edit
        such content, at its sole discretion. If you do post content or submit
        material, and unless we indicate otherwise, you grant Augmont a
        nonexclusive, royalty-free, perpetual, irrevocable, and fully
        sublicensable right to use, reproduce, modify, adapt, publish,
        translate, create derivative works from, distribute, and display such
        content throughout the world in any media. You grant Augmont and its
        sublicensees the right to use the name that you submit in connection
        with such content if they choose. You represent and warrant that you own
        or otherwise control all of the rights to the content that you post;
        that the content is accurate; that use of the content you supply does
        not violate this policy and will not cause injury to any person or
        entity; and that you will indemnify Augmont for all claims resulting
        from content you supply. Augmont has the right but not the obligation to
        monitor and edit or remove any activity or content. Augmont takes no
        responsibility and assumes no liability for any content posted by you or
        any third party.
      </p>

      <strong>SITE POLICIES, MODIFICATION, AND SEVERABILITY</strong>
      <p>
        Please review our other policies posted on this site. These policies
        also govern your visit to the Platform. We reserve the right to make
        changes to our site, policies, and these Terms and Conditions of Access
        and Use at any time. If any of these Terms and Conditions of Access and
        Use is deemed invalid, void, or for any reason unenforceable, that
        condition shall be deemed severable and shall be modified so as to give
        effect to the economic intent of such impugned provision, and shall not
        affect the validity and enforceability of the remaining Terms and
        Conditions of Access and Use.
      </p>

      <strong>TERMINATION</strong>
      <p>
        Augmont reserves the right to discontinue, in whole or in part, any
        portion of the Platform services or programs with or without notice.
        This discontinuation may relate to all users, certain groups of users,
        or to certain individual users. This Agreement and the license rights
        granted hereunder shall remain in full force and effect unless
        terminated or cancelled for any of the following reasons: (a)
        immediately by Augmont for any unauthorized access or use by you; (b)
        immediately by Augmont if you assign or transfer (or attempt to do so)
        any rights granted to you under this Agreement; (c) immediately if you
        violate any of the other terms and conditions of Terms and Conditions of
        Access and Use. Termination or cancellation of this Agreement shall not
        affect any right or relief to which Augmont may be entitled at law or in
        equity. Upon termination of this User Agreement, all rights granted to
        you will terminate and return to Augmont.
      </p>

      <strong>VOID WHERE PROHIBITED</strong>
      <p>
        Although the Platform is accessible worldwide, not all products or
        services discussed or referenced on the Platform are available to all
        persons or in all geographic locations or jurisdictions. The Platform
        reserves the right to limit the provision of any product or service to
        any person, geographic area or jurisdiction it so desires, in its sole
        discretion and to limit the quantities of any such product or service
        that it provides. Any offer for any product or service made on the
        Platform is void where prohibited.
      </p>

      <strong>YOUR ACCOUNT</strong>
      <p>
        If you use this site, you are responsible for maintaining the
        confidentiality of your account and password and for restricting access
        to your computer, and you agree to accept responsibility for all
        activities that occur under your account or password. Augmont does not
        offer services or sell products to parties under the age of 18 years.
        Augmont reserves the right to refuse service, terminate accounts, remove
        or edit content, or cancel orders and instructions at its sole
        discretion.
      </p>

      <strong>ELIGIBILITY</strong>
      <p>
        You may use the Platform only if you are an Indian citizen, residing in
        India, and are eligible to enter into contracts under Indian law.
        Non-Indian citizens and non-resident Indians cannot participate on the
        Platform at present.
      </p>

      <strong>YOUR REGISTRATION OBLIGATIONS</strong>
      <p>
        In consideration of your use of the Platform, you agree to:
        <ul>
          <li>
            Provide true, accurate, current, and complete information about
            yourself as prompted by the registration form required by the
            Platform (such information being the "Registration Data"), and
          </li>
          <li>
            Maintain and promptly update the Registration Data to keep it true,
            accurate, current, and complete. In addition, if required you fill
            and sign all forms and documents which form part of your account
            opening kit and supply us with all the relevant legal documents and
            financial information which law requires us to maintain. You warrant
            and represent that all information that you supply to us is accurate
            and truthful. You also expressly authorize Augmont to obtain reports
            concerning your credit standing and business conduct. You can open
            an Augmont account with us by entering your mobile number and
            verifying the same with after verifying your OTP sent to your mobile
            number. Notwithstanding the foregoing, we may provide you with
            access to some parts of the Platform without you registering as a
            user. In that case, your identification is based on other means of
            identification that we deem appropriate. You warrant and represent
            that all information provided for this other means of identification
            is accurate and truthful. You further agree that such information
            may be collected and disclosed to us and used in accordance with
            these Terms and Conditions of Access and Use.
          </li>
        </ul>
      </p>

      <strong>DISAPPROVAL OF APPLICATION</strong>
      <p>
        If you provide any information that is untrue, inaccurate, not current,
        or incomplete, or Augmont has reasonable grounds to suspect that such
        information is untrue, inaccurate, not current, or incomplete, Augmont
        has the right to suspend or terminate your account and refuse any and
        all current or future use of the Platform (or any portion thereof)
        without any liability to you.
      </p>

      <strong>ACCOUNT SECURITY</strong>
      <p>
        Upon completing the registration process with the Platform, the system
        will create a unique customer ID for you. You are responsible for
        maintaining the confidentiality of your account and are fully
        responsible for all activities that occur under your account. You agree
        to (a) immediately notify Augmont of any unauthorized use of your
        password or account or any other breach of security, and (b) ensure that
        you exit from your account at the end of each session.
      </p>

      <strong>TERMINATION OF ACCOUNT</strong>
      <p>
        You agree that Augmont, in its sole discretion, may terminate your
        password, Account, or your use of the Platform. Augmont may terminate
        your Account and remove any content within the Platform for any reason,
        including, without limitation, if Augmont, in its sole opinion, believes
        that you have violated or acted inconsistently with the letter or spirit
        of these Terms and Conditions of Access and Use. Augmont may also, in
        its sole discretion and at any time, discontinue the Platform, or any
        part thereof, without notice. You may also request Augmont to terminate
        your account with us by sending an email to the customer help desk from
        your registered email ID. You agree that any termination of your access
        to the Platform under any provision of these Terms and Conditions of
        Access and Use may be effected without prior notice and acknowledge and
        agree that Augmont may immediately deactivate or delete your account and
        all related information and files in your account and/or bar any further
        access to such files or to the Platform. Further, you agree that Augmont
        shall not be liable to you or any third-party for any termination of
        your access to the Service. However, on such termination, Augmont shall,
        based on the request from the customer, deliver the bullion lying in the
        vaults in the form of coins and/or bars, sell the fractional parts, and
        return the net amount of money standing to the credit of your Account.
      </p>

      <strong>INVESTMENT DECISIONS</strong>
      <p>
        Augmont may publish research and opinions on the Platform, for your
        information. You may not rely on any such information for forming your
        investment decisions. You acknowledge that Augmont or the Platform and
        its officers, directors, employees, agents, and affiliates will have no
        liability with respect to transactions in or for your Account and your
        investment decisions.
      </p>

      <strong>SYSTEMS</strong>
      <p>
        Operations on the Platform shall be conducted on an automated basis.
        Registered Members will be required to connect to the Platform over the
        Internet. Operations on the Platform shall be allowed through suitable
        internet-connected devices of a Registered Member. Each Registered
        Member shall login to their respective Augmont account by entering their
        respective mobile number. A Registered Member shall have a non-exclusive
        permission to use the Platform in the ordinary course of business. A
        Registered Member shall not have any title, rights, or interest with
        respect to the Platform, its facilities, software, and the information
        provided by Augmont and the Platform. The permission to use the Platform
        shall be subject to the payment of such charges as Augmont and the
        Platform may prescribe from time to time. A Registered Member shall not,
        by themselves or through any other person(s), directly or indirectly:
      </p>
      <ul>
        <li>
          Use the Platform for any purpose other than that approved and
          specified by the Platform;
        </li>
        <li>
          Copy, alter or modify the Platform, or make the Platform available to
          any other person;
        </li>
        <li>
          Use the Platform in any manner other than the manner as specified by
          Augmont;
        </li>
        <li>
          Attempt - directly or indirectly - to decompile, dissemble, or reverse
          engineer the Platform;
        </li>
        <li>
          Publish, supply, show or make available to any other person or
          reprocess, retransmit, store, or use the facilities of the Platform.
        </li>
      </ul>

      <strong>CONTROL & REPORTING SYSTEMS</strong>
      <p>
        The Platform may, at the decision of Augmont, cease operations in
        Bullion (Selected denominations of Gold and Silver as specified by the
        Platform) on the system for such an amount of time and for such reasons
        as it may deem fit in the best interests of the Registered Members and
        the overall markets. Orders, if any, in violation of an operation cease,
        will be rejected by the Platform.
      </p>
      <p>
        Details of transactions conducted by Registered Members would be updated
        with the back-office systems of Augmont on a real-time basis. Registered
        Members can access the reports of their transactions over the Platform.
        Augmont may record such additional information about the buying and
        selling conducted on the Platform as it may consider relevant or
        necessary for its own use.
      </p>

      <strong>INTERMEDIARIES</strong>
      <p>
        Augmont may appoint Intermediaries and Distributors who shall assist us
        in distributing our products to you. Augmont shall communicate all the
        transaction details to you directly by means of emails, SMS, and any
        other medium, and it is your responsibility to ensure that you receive
        this communication. When you visit the Platform or send e-mails to us,
        you are communicating with us electronically. You consent to receive
        communications from us electronically. We may communicate with you by
        one or more of letters, e-mail, SMS, or by posting notices on the
        Platform. You agree that all agreements, notices, disclosures, and other
        communications that we provide to you electronically satisfy all legal
        requirements that such communications be in writing. Augmont shall not
        be responsible to you in the event of default or any wrongful,
        dishonest, criminal, fraudulent act, or willful misconduct or gross
        negligence on the part of these Intermediaries. However, you shall
        immediately inform Augmont of the occurrence of such an event through
        e-mails/telephone/fax, or any other convenient means. The activities of
        the Intermediaries and its personnel/representative(s) shall not be
        construed to be activities of Augmont.
      </p>

      <strong>FORCE MAJEURE</strong>
      <p>
        In case of the inability of Augmont to make deliveries of coins, bars,
        and jewelry bullion due to reasons beyond its control, Augmont may
        require that the deliveries be effectuated through specific modes,
        including through local agents/jewelers. In such a case, you agree to
        bear any additional costs and fees necessary for the delivery to be
        complete.
      </p>

      <strong>
        TERMS & CONDITIONS FOR DIGIGOLD AND SYSTEMATIC INVESTMENT PLAN DIGIGOLD:
      </strong>
      <p>
        Through the Platform, Augmont shall facilitate the buy and sell of Gold
        and Silver (Bullion). All such buy and sell transactions are final and
        non-reversible. Augmont shall provide buy/sell quotes for the prices of
        Bullion, which shall be linked, based on a formula, to the prices of
        gold and silver in the spot market. You may buy any quantity of Bullion
        through the Platform, subject to policies framed in this regard by
        Augmont. Augmont shall issue an invoice with Bullion (as the case may
        be) purchased by you. The Bullion purchased will be delivered to and
        stored with a custodian in a vault on your behalf and at your request by
        default. The cost of insurance of Bullion will be borne by Augmont. You
        shall have the option to:
      </p>
      <ol>
        <li>
          Sell gold/silver from your Platform account back to Augmont at the
          prices shown on the Platform at the time of sale, or
        </li>
        <li>
          Request for the delivery of the gold/silver in the form of coins and
          bars online from us, or
        </li>
        <li>Transfer the gold/silver to another account.</li>
      </ol>

      <strong>BUSINESS DEPOSIT</strong>
      <p>
        A Registered Member’s account ("Account") shall always reflect the
        business deposit balance in their Platform account and the balance of
        net bullion purchased by them lying in the vault. The Registered Member
        may transfer business deposit money with Augmont and withdraw the same
        from the Platform Account as and when required.
      </p>
      <p>
        By clicking on the "Deposit Funds" tab on the website, you will be
        provided with various options for depositing advance money like Net
        Banking, Debit Card, RTGS, NEFT, NACH, Wallet, Cheque, and DD. By
        Clicking on Net Banking or Debit Card, you will be redirected to the
        online payment gateway. You can then transfer such business deposit to
        Augmont, and the same will reflect in your Platform account immediately.
        In case of payments done by RTGS, NEFT, Cheque, or DD, your Platform
        account will be credited within 48 Hours of receipt of such business
        deposit by Augmont. Surplus funds lying in a Platform Account of a
        Registered Member shall remain with Augmont. The Registered Member may
        place a request for the withdrawal of a specific amount from the
        business deposit with Augmont. Augmont shall transfer such an amount to
        the bank account of the concerned Registered Member within seven working
        days from the date of receipt of such withdrawal request. In case such
        surplus funds are lying with Augmont for a period of more than 180 days,
        the system shall generate a withdrawal request of such surplus funds,
        and the same shall be transferred to the bank account of the concerned
        Registered Member within seven working days. However, Augmont may deduct
        charges for generating such withdrawal request as per its own
        discretion. You cannot withdraw the amount from your account to your
        bank account without performing any buy and sell transactions. When you
        buy gold/silver through your Account on the Platform, you can use the
        amount of the business deposit towards the amount payable for the
        purchase in your Account. Similarly, when you sell gold/silver from your
        Account on the Platform, the amount of the transaction can be added to
        the business deposit or bank account as per your request in your
        Account. No interest would be payable on the business deposits
        maintained by you in the Account or with Augmont. You may withdraw a
        part or the entire business deposit in your Account upon request to
        Augmont. The withdrawal may be effectuated by such means as Augmont may
        decide at its sole discretion. Such means may include electronic
        transfer of funds to your bank account and payment through a cheque.
        While it is unlikely, there could be a negative deposit in your Account
        due to reasons such as charges debit, inadvertently processing buy
        orders exceeding the business deposit, technical issues, etcetera. In
        such a case, you would promptly transfer funds to your Platform Account
        to the extent of the negative balance. If payment is not received within
        a reasonable time, your Account may be closed, without prior
        notification. In such an event, you will be liable for any resulting
        losses and all associated costs incurred by Augmont.
      </p>
      <strong>PLACEMENT OF ORDERS</strong>
      <p>
        The market prices of bullion shown on the Platform would be an
        invitation to offer to all eligible Account holders. An order
        legitimately placed by an eligible Account holder would constitute an
        offer for the purchase or sale of the Gold or Silver, as the case may
        be. Augmont may accept or reject such an offer, at its discretion.
      </p>
      <p>
        Though orders would usually be attended to within seconds, certain
        orders, at Augmont's discretion, may be subject to manual review and
        entry, which may cause delays in the processing of your orders. You also
        accept that you will receive the price at which your order executes in
        our systems, which may be different from the price at which Gold or
        Silver is trading at when you enter your order into our system. You
        acknowledge that you cannot modify an order once placed and that orders
        may get executed at a price significantly unfavorable to you, depending
        upon market fluctuations.
      </p>

      <strong>BUYING / SELLING</strong>
      <p>
        The common parameters with respect to buying / selling are as follows:
      </p>
      <ul>
        <li>
          Buy / Sell Price Spreads: The Platform will continuously provide buy /
          sell prices for the gold / silver on the platform. The buy / sell
          prices and the spread between them could change on the basis of
          various factors including price volatility, supply factors, external
          market conditions, etc.
        </li>
        <li>
          Price Quote Requests: Registered Members could request market price
          quotes for gold / silver they wish to buy / sell in, and could buy and
          sell at the quoted price by placing orders. Currently, this facility
          is not available.
        </li>
        <li>
          An order that does not conform to the specifications laid down by
          Augmont and the Platform shall be considered as void.
        </li>
        <li>
          Quantity of Gold / Silver earned through any promotional offers on
          Augmont app is non-saleable. However, a customer can request a
          physical delivery of this Gold / Silver by paying nominal making and
          delivery charges.
        </li>
        <li>
          Cashback or amount received through any promotional offers on Augmont
          app cannot be withdrawn. However, this can be used to purchase Gold /
          Silver or to request physical delivery of Gold / Silver on the Augmont
          app.
        </li>
      </ul>

      <strong>Buying / Selling Functions</strong>
      <p>Following functions can be performed by the Registered member:</p>
      <ul>
        <li>
          Buy: A Registered member can buy gold and silver in any quantity in
          grams up to four decimals. There is no upper limit on the purchase
          quantity. The customer shall pay the amount using a payment gateway
          immediately at the time of buying the gold/silver. Upon successful
          execution of buying, the purchased Bullion will reflect in the
          Registered Member’s Platform Account. The Registered Member can also
          utilize his/her business deposit for the buying of Gold and Silver. On
          execution of every buy order, Augmont / the Platform will purchase the
          corresponding quantity of physical Bullion (as the case may be) and
          deliver it to the custodian who stores their bullion in the designated
          secured vaults.
        </li>
        <li>
          Hold: The Bullion purchased by a Registered Member can be stored with
          the custodian in a designated vault.
        </li>
        <li>
          Sell: The gold and silver held by a Registered Member can be sold back
          to Augmont in any quantity in grams up to four decimals. Registered
          member can sell only the bullion which is lying in the vault on
          his/her behalf. Upon successful execution of sale, the sold quantity
          of Bullion will be deducted from the Registered Member’s Platform
          Account, and the appropriate amount of funds will be added to his/her
          Account. The gold or silver bought cannot be sold within 48 hours from
          the time of buying.
        </li>
      </ul>

      <strong>TAXES, BROKERAGE AND OTHER CHARGES</strong>
      <p>
        No brokerage will be charged to Registered Members for any buy and sell
        done by them. For each buy and sell conducted by a Registered Member, an
        e-invoice will be generated in the name of the Member. All taxes,
        duties, levies, etc., as applicable, will be borne by the concerned
        Registered Member. Augmont shall not be responsible for such statutory
        taxes.
      </p>

      <strong>AGENTS</strong>
      <p>
        In order to ensure smooth and efficient operations, Augmont may appoint
        one or more agents (including a Commission agent) on your behalf, from
        time to time. If required, you agree to ratify such appointment(s)
        retrospectively. All agents shall have the right to terminate their
        appointment at any time, without prior notice to you. The Commission
        agent appointed by Augmont on your behalf shall be appointed for the
        limited purpose of representing you and acting on your behalf - to take
        deliveries/constructive deliveries, make and receive payments for trades
        done by you on the Platform. Your acceptance of these Terms and
        Conditions of Access and Use shall form consideration for the
        appointment of the Commission Agent. All payments from and to you shall
        be appropriated through the Commission agent as and when required.
        Notwithstanding the above mechanism, all statutory liability (including
        GST and other applicable taxes) shall always be to your account, and you
        shall indemnify the Commission Agent for any losses suffered for acting
        as your agent.
      </p>

      <strong>REQUEST DELIVERY</strong>
      <p>
        The Platform offers services for users who wish to request the delivery
        of the gold and silver bought by the users and lying in the vaults. The
        Platform displays the articles that are available for delivery along
        with the making and delivery charges for each article. Some items may
        appear slightly larger or smaller than actual size due to screen
        defaults and photography techniques. Sometimes the items may be
        represented larger than the actual size in order to clearly show details
        or smaller than the actual size in order to show the entire item. The
        Company shall not be liable for any legal action on this account. All
        the details regarding the product shall be clearly displayed on the
        Platform. This facility shall be available to all registered users of
        the Platform. Any registered user who wishes to request delivery of the
        gold and silver from the Platform can choose from the selection of
        Jewellery and Coins and Bars available on the Platform and add the item
        to the shopping cart.
      </p>

      <strong>Product</strong>
      <p>
        Infrequently, data may be inaccurately displayed on the Platform due to
        system errors. Augmont reserves the right to correct any and all errors
        when they do occur, and Augmont shall not honor inaccurate or erroneous
        prices. The delivery charges on the Platform are also subject to change
        without notice. For any order, the delivery charges on the day the order
        is confirmed prevail. The delivery charges of the products listed on the
        Platform are fixed and not negotiable.
      </p>

      <strong>Delivery</strong>
      <p>
        Delivery shall be made by the Company / courier agent at your doorstep.
        All items shall be delivered directly to such person, and under any
        circumstances whatsoever, the Member cannot change the recipient details
        after the order is processed. The Member has the option to change the
        shipping address before the product is actually shipped. In the event
        the Member wishes to change the shipping address, he/she has to log in
        to his/her user account on the Platform and click on the "Change
        Shipping Address" button next to the shipping address and change the
        address or can request the helpdesk via email. However, the Shipping
        Address cannot be changed once the order is processed. Recipient
        accepting delivery should carefully examine the package delivered and
        shall not accept deliveries where the packaging has been tampered with.
        The recipient receiving the delivery also has the option to open the
        package and check its contents prior to accepting the delivery or
        signing the delivery receipt. They shall not accept deliveries where
        they find that the box is empty or the contents are damaged or the
        contents are not in accordance with the order placed. The recipient,
        upon signing the delivery receipt, acknowledges the receipt of the
        product in terms of the order placed with the Company. The Company is
        not liable to the Customer / recipient for any refund / replacement,
        under any circumstance, for any subsequent complaints with respect to
        such deliveries. If the recipient is not available at the time of
        delivery, the Company / courier agent shall try and deliver the item
        thrice before returning the same to Augmont. All costs for re-shipment
        and handling in the case of non-delivery to the Customer shall be
        chargeable to the Customer.
      </p>

      <p>
        <strong>Return & Replacement Policy</strong>
      </p>
      <p>
        In the event you receive a damaged/defective article or an article that
        does not comply with the specifications as per your original order, you
        are required to get in touch with the customer service team within 3
        business days from the date of receipt of such delivery. Upon receiving
        your complaint, Augmont shall verify the authenticity and the nature of
        the complaint. If Augmont is convinced that the complaint is genuine,
        Augmont shall provide a free replacement subject to the Product being
        sealed and is returned in the same tamper-proof blister packaging in
        which it was delivered to the Customer. However, in the event of
        frivolous and unjustified complaints regarding the quality and content
        of the products, Augmont reserves the right to pursue necessary legal
        actions against you, and you will be solely liable for all costs
        incurred by Augmont in this regard. Before accepting shipment of any
        product, kindly ensure that the product’s packaging is not damaged or
        tampered. If you observe that the package is damaged or tampered,
        request you to refuse to accept delivery and inform Augmont at the
        earliest. The return process of the product may be restricted by Augmont
        depending on the nature and category of the product.
      </p>

      <p>
        <strong>Refunds</strong>
      </p>
      <p>
        Any refunds due by Augmont to the user for non-availability of articles
        shall be credited to the registered user’s business deposits balance
        with Augmont.
      </p>

      <p>
        <strong>TRANSFER THROUGH SUCCESSION</strong>
      </p>
      <p>
        Any gold/silver lying in vault and the business deposit is
        non-transferrable unless specifically allowed by Augmont. However, in
        the case of death or insanity, Augmont shall transfer such gold/silver
        and advance balance to your legal heir(s) after the required due
        diligence, and your legal heir(s) shall be regarded as the Registered
        User thereafter.
      </p>

      <p>
        <strong>SYSTEMATIC INVESTMENT PLAN</strong>
      </p>
      <ul>
        <li>
          Systematic Investment Plan (henceforth referred to as “SIP") is a
          disciplined accumulation of Gold/Silver.
        </li>
        <li>
          The SIP enables the member to buy gold and silver of a certain fixed
          amount every month and accumulate Gold/Silver at periodic intervals at
          a “Configured Price”.
        </li>
        <li>
          The Configured Price for SIP shall be calculated by the Platform on
          every Business Day and shall be displayed on the Platform before 1 pm
          which shall be final and binding for everyone. A Business Day means
          any day other than Sunday or a day declared as a holiday under the
          Negotiable Instruments Act, 1881 or a day on which normal business
          could not be transacted due to storms, floods, strikes, riots, or any
          other events as Augmont may specify from time to time.
        </li>
        <li>
          To start the SIP, the member needs to log in to his/her account, click
          on the SIP link and fill in a simple form specifying the choices and
          submit. After successfully submitting SIP application, the member will
          get a confirmation SMS/email.
        </li>
        <li>
          The member can start their SIP with the minimum amount of Rs. 1000 per
          month and can invest in multiples of Rs.1000 thereafter.
        </li>
        <li>
          The member gets an option to buy additional quantities of gold and
          silver in the existing SIP, and the said quantity shall be added to
          the SIP quantity for the tenure. The member can choose the duration of
          this SIP, which can range from 1 year to 10 years.
        </li>
        <li>
          The member gets an option to choose the SIP date cycle from the four
          options viz. 5th/12th/19th/26th of every month. E.g. If the member
          submits the SIP application on 7th October and selects the SIP cycle
          date as 12th of each month, then the SIP will initiate on 12th
          October. However, if they choose the SIP cycle date as 5th of each
          month, then the SIP start date will be 5th November.
        </li>
        <li>
          One cannot change the amount of SIP, duration, and cycle date once the
          request is submitted. In order to change, one has to terminate the
          existing SIP and register for a new one. There are no charges
          currently for doing the same.
        </li>
        <li>
          The frequency of buying is once per month. So, if the member chooses
          the SIP amount to be Rs 1000 per month in SIP, Rs. 1000 is utilized
          for purchasing the Gold/Silver. The Registered Member can request for
          termination of his existing SIP by contacting the customer help desk.
          SIP will be terminated only upon the completion of the current SIP
          cycle month. E.g. If the member has selected 5th of every month as his
          SIP cycle date and his SIP is active, and the member decides to exit
          the SIP on 10th of the month, the cycle will continue till 4th of the
          next month and then terminate. At the end of SIP tenure or on SIP
          termination, the member may sell the gold and silver at the market
          price displayed on the Platform. Alternatively, the member can request
          for termination of his account with us, in which case, the gold and
          silver shall get sold at the market rate and the proceeds shall be
          remitted to the member's bank account.
        </li>
        <li>
          You may not sell Gold/Silver under SIP, but you can request the
          delivery of the gold and silver accumulated during the tenure of the
          SIP. Alternatively, you may sell the gold and silver under the SIP at
          the end of the tenure.
        </li>
        <li>
          In case you miss your monthly SIP installment, you will be given a
          grace period of 60 days. Within the grace period, if you do not
          transfer sufficient funds in your account, then your SIP may be
          treated as 'defaulted' and your SIP may be irreversibly terminated.
        </li>
        <li>
          The SIP is neither a financial product nor a deposit scheme but a
          disciplined method of accumulating Gold/Silver. Augmont offers no
          investment advice or any assured returns while promoting the SIP.
        </li>
      </ul>
      <p>
        <strong>TERMS AND CONDITIONS FOR EMI</strong>
      </p>
      <ul>
        <li>
          The Scheme is unique and shall not be linked to any other existing or
          future Schemes/Offers and is not transferable under any circumstances.
        </li>
        <li>
          The product purchased and the specifications mentioned upon Order
          Confirmation cannot be changed during the tenure of the scheme, and
          the Customer shall make the payments as per the payment schedule
          provided during Order confirmation.
        </li>
        <li>
          The money paid as a booking amount under the Scheme shall not bear any
          interest.
        </li>
        <li>
          Augmont shall issue a system-generated Proforma Invoice to the
          customer at the time of Order Confirmation, a Payment Receipt upon
          payment of every EMI, and Final Tax Invoice at the time of Delivery of
          the Product. The product shall be delivered at the delivery location
          provided by the Customer within 14 working days of receiving the full
          payment from the Customer.
        </li>
        <li>
          The Customer may be provided a grace period of 5 days every month
          beyond his/her respective payment due date. In case the customer fails
          to make payment beyond such grace period, then Augmont, at its sole
          discretion, may cancel the order as per the terms explained below.
        </li>
        <li>
          When a Customer cancels the Purchase Order before the payment of the
          last EMI or where Augmont cancels the Purchase Order of the Customer
          pursuant to the above, Augmont shall be entitled to deduct such
          charges in the following manner from the amount paid by the Customer
          towards the Purchase of the Product:
          <ul>
            <li>
              The cancellation charges for each product shall be updated by
              Augmont on a daily basis for facilitating cancellation.
            </li>
            <li>
              If the cancellation charges as on the date and time of
              cancellation are higher/lower than the Order Value, then the
              difference between the order value and the cancellation rate as on
              the date of cancellation plus an amount equivalent to 2.36% of the
              order value shall be deducted from the payments made by the
              customer, and the balance shall be refunded to the customer’s bank
              account only.
            </li>
          </ul>
        </li>
        <li>
          Any changes in GST or any other government taxes shall be collected
          from the customer at the time of delivery/closure.
        </li>
        <li>
          In the unfortunate event of the death of the customer, the product
          shall be handed over to the legal heir of the Customer after due
          verification.
        </li>
        <li>
          Augmont reserves the right to alter the terms and conditions without
          intimation to the customer, and the customer shall abide by such
          alterations. In case of any dispute, the courts of Mumbai shall have
          exclusive jurisdiction to resolve such disputes.
        </li>
        <li>
          Order fulfillment by Augmont is subject to the realization of the
          total Purchase Price from the Customer.
        </li>
        <li>
          The Customer is advised that proper KYC is updated at the time of
          purchasing the Product to enable Augmont to identify the bona fide
          Customer. In any case, the Customer will be prompted to provide their
          PAN details once the Customer’s Purchase Order reaches a certain
          threshold limit.
        </li>
        <li>
          Augmont reserves the right to stop facilitating the Scheme on the
          Platform at its sole discretion. All Orders previously placed shall
          stand active and shall be fulfilled by Augmont.
        </li>
        <li>
          Augmont does not charge any processing fee for the purpose of
          facilitating the Scheme for its Customers.
        </li>
        <li>
          The photographs and impressions displayed on the platform are for
          reference only and are not to scale. The size, color, finish, lustre,
          and other visual parameters of the actual product may differ to an
          extent from the photographs and impressions displayed on the Platform.
          The Products shall be considered to have a defect in quality if they
          have an inherent material or manufacturing defect. Minor deviations
          from the image shown on the Platform shall not qualify as a defect.
          Augmont shall not be liable for any action on this account.
        </li>
        <li>
          Augmont or Platform shall not be responsible for any unauthorized use
          of credit or debit cards for making any transaction and shall have no
          liability either to the true holder of any credit or debit card or to
          the concerned bank for any unauthorized/fraudulent use of payment
          instruments. In no event shall Augmont be held liable to the true
          holder of any credit or debit card or to the concerned bank for
          processing and fulfilling its obligation upon the realization of the
          entire Purchase Price towards such fraudulent transaction.
        </li>
        <li>
          Augmont will communicate with the Customer by email or other
          electronic methods, which will be deemed as adequate means for the
          service of notice or communication.
        </li>
        <li>
          All transactions on the Platform and use of services of Augmont shall
          be subject to true, fair, and accurate disclosure of information by
          the Customer as may be called for.
        </li>
        <li>
          The recipient of the Products is obliged to produce identity proof
          and/or address proof or such other documents to verify and establish
          as being a bona fide Purchaser/Recipient at the time of delivery to
          ensure safe delivery of the Products purchased.
        </li>
      </ul>

      <p>
        <strong>Delivery</strong>
      </p>
      <ul>
        <li>
          Delivery shall be made by the Company/courier agent at your doorstep.
          All items shall be delivered directly to such person, and under any
          circumstances whatsoever, the Member cannot change the recipient
          details after the order is processed. The Member has the option to
          change the shipping address before the product is actually shipped. In
          the event, the Member wishes to change the shipping address, he/she
          has to log in to his/her user account on the Platform and click on the
          "Change Shipping Address" button next to the shipping address and
          change the address or can request the helpdesk via email. However, the
          Shipping Address cannot be changed once the order is processed.
        </li>
        <li>
          Recipient accepting delivery should carefully examine the package
          delivered and shall not accept deliveries where the packaging has been
          tampered with. The recipient receiving the delivery also has the
          option to open the package and check its contents prior to accepting
          the delivery or signing the delivery receipt. They shall not accept
          deliveries where they find that the box is empty or the contents are
          damaged or the contents are not in accordance with the order placed.
        </li>
        <li>
          The recipient, upon signing the delivery receipt, acknowledges the
          receipt of the product in terms of the order placed with the Company.
          The Company is not liable to the Customer/recipient for any
          refund/replacement, under any circumstance, for any subsequent
          complaints with respect to such deliveries.
        </li>
        <li>
          If the recipient is not available at the time of delivery, the
          Company/courier agent shall try and deliver the item thrice before
          returning the same to Augmont. All costs for re-shipment and handling
          in the case of non-delivery to the Customer shall be chargeable to the
          Customer.
        </li>
      </ul>

      <p>
        <strong>Refunds</strong>
      </p>
      <p>
        For any order failures or customer dissatisfaction, Refund will be
        credited in 7-10 working days to orginal payment method.
      </p>
    </div>
  );
};

export default Terms;
